import { DropdownItem } from '@factorialco/f0-react/dist/experimental'
import { IntegrationsSyncableStateStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import {
  type MergeableStatuses,
  MergedStatus,
  mergeStatuses,
} from 'modules/integrations/lib/syncableStatus'

const translatedGroupedStatus = (mergedStatus: MergedStatus, isExportMode: boolean): string => {
  if (isExportMode) {
    switch (mergedStatus) {
      case 'syncing':
        return i18n.t('integrations.export_tooltips.exporting')
      case 'pending':
        return i18n.t('integrations.export_tooltips.pending')
      case 'outdated':
        return i18n.t('integrations.export_tooltips.outdated')
      case 'partiallySynced':
        return i18n.t('integrations.export_tooltips.partially_exported')
      case 'failed':
        return i18n.t('integrations.export_tooltips.failed')
      case 'synced':
        return i18n.t('integrations.export_tooltips.exported')
      default:
        throw new Error(`Unknown grouped status: ${mergedStatus}`)
    }
  }

  switch (mergedStatus) {
    case 'syncing':
      return i18n.t('integrations.sync_tooltips.syncing')
    case 'pending':
      return i18n.t('integrations.sync_tooltips.pending')
    case 'outdated':
      return i18n.t('integrations.sync_tooltips.outdated')
    case 'partiallySynced':
      return i18n.t('integrations.sync_tooltips.partially_synced')
    case 'failed':
      return i18n.t('integrations.sync_tooltips.failed')
    case 'synced':
      return i18n.t('integrations.sync_tooltips.synced')
    default:
      throw new Error(`Unknown grouped status: ${mergedStatus}`)
  }
}

export const statusesItems = (
  statusesGroups: Array<MergeableStatuses | Set<IntegrationsSyncableStateStatusEnum>>,
  isExportMode: boolean
): DropdownItem[] => {
  const items: DropdownItem[] = []

  statusesGroups
    .map((statuses) => {
      const statusesArray: MergeableStatuses =
        statuses instanceof Set
          ? Array.from(statuses)
          : Array.isArray(statuses)
            ? statuses
            : statuses
      return mergeStatuses(statusesArray)
    })
    .reduce((map, groupedStatus) => {
      if (groupedStatus == undefined) return map
      map.set(groupedStatus, (map.get(groupedStatus) ?? 0) + 1)
      return map
    }, new Map<MergedStatus, number>())
    .forEach((value, key) => {
      if (key === 'syncing') return

      items.push({
        label: `${translatedGroupedStatus(key, isExportMode)}: ${value}`,
        critical: key === 'failed',
      })
    })

  return items
}
